import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e08e669c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "boxItem" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "boxTitle" }, "跳转类型：", -1))
const _hoisted_3 = { class: "boxItem" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "boxTitle" }, "跳转地址：", -1))
const _hoisted_5 = {
  key: 0,
  target: "_blank",
  href: "https://o15vj1m4ie.feishu.cn/wiki/wikcnH0UmDnOI42nF6LrGf809KY",
  class: "link ml-80"
}
const _hoisted_6 = {
  key: 1,
  class: "boxItem"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "boxTitle" }, "通用选项：", -1))
const _hoisted_8 = {
  key: 0,
  class: "lineBox"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "宽高比：750 /", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "redText" }, "【页面在半屏场景的宽高比（750/页面的高度）】", -1))
const _hoisted_11 = {
  key: 1,
  class: "lineBox"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "高度比例：", -1))
const _hoisted_13 = {
  key: 2,
  class: "lineBox"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "背景色：", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "link",
  target: "_blank",
  href: "https://o15vj1m4ie.feishu.cn/wiki/IGeOwnV2ciSwWokAsPqcg2OrnQh"
}, "色值可参考此文档", -1))
const _hoisted_16 = {
  key: 3,
  class: "lineBox"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "加载过程背景色：", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "link",
  target: "_blank",
  href: "https://o15vj1m4ie.feishu.cn/wiki/IGeOwnV2ciSwWokAsPqcg2OrnQh"
}, "色值可参考此文档", -1))
const _hoisted_19 = {
  key: 2,
  class: "boxItem"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "boxTitle" }, "地址参数：", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-10 redText" }, "规则：多个参数用&隔开。如：", -1))
const _hoisted_22 = { class: "boxItem end" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "boxTitle" }, "最终地址：", -1))
const _hoisted_24 = { class: "textarea" }
const _hoisted_25 = { class: "flex" }

import { ref, computed, onMounted } from "vue";
import {
  Alert,
  Input,
  Select,
  InputNumber,
  Modal,
  message,
} from "ant-design-vue";


const __default__ = {
  name: "behind-jump",
};


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    url: {},
    open: { type: Boolean }
  },
  emits: ["ok", "cancel"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const options = ref([
  { label: "全屏展示、隐藏半屏的返回按钮（隐藏导航栏）", value: "hide_nav=1" },
  { label: "半屏展示", value: "present=1", disabled: false },
  { label: "禁用离线包", value: "h5_offline=0" },
  { label: "隐藏全屏按钮", value: "hide_full=1" },
  { label: "网页容器透明", value: "is_transparent=1" },
  { label: "右上角带分享按钮", value: "showShareBtn=1", disabled: false },
  { label: "宽高比", value: `aspect_ratio=` },
  { label: "网页容器之外背景色", value: `present_contentColor=` },
  { label: "网页跟随软键盘", value: `can_float=1` },
  { label: "网页容器不圆角", value: `hide_corner=1` },
  { label: "手势右滑直接退出页面", value: `close_wv_by_gesture=1` },
  { label: "禁用容器弹性效果", value: `bounce_disable=1` },
  { label: "开启 http 缓存", value: `x_cache=1` },
  { label: "高度比例", value: `height_ratio=` },
  { label: "加载过程背景色", value: `web_loading_backcolor=` },
]);

const typeOptions = [
  { label: "跳转H5", value: "h5" },
  { label: "app原生跳转/自定义跳转", value: "app" },
];

const emit = __emit;

const fn = () => {
  Modal.confirm({
    title: "关闭将丢失编辑内容",
    content: "你确定要关闭吗？",
    okText: "确定",
    cancelText: "取消",
    zIndex: 5001,
    onOk() {
      // console.log('OK');
      // jumpType.value = 'h5'
      // addressJump.value = ''
      // common.value = []
      // addressParams.value = ''
      emit("cancel");
    },
    onCancel() {
      console.log("Cancel");
    },
  });
};

const copy = () => {
  navigator.clipboard
    .writeText(lastVal.value)
    .then(() => {
      console.log("Text copied to clipboard");
      message.success("复制成功");
    })
    .catch((err) => {
      console.error("Error in copying text: ", err);
    });
};

const contentColor = ref("#000000B3");
const loadColor = ref("#00000000");
const common = ref<string[]>([]);
const jumpType = ref("h5");
const addressParams = ref("");
const addressJump = ref("");
const height = ref(1136);
const heightRatio = ref(1);
const bigBox = ref<HTMLDivElement>();

const filterOption = (aa: unknown[]) => {
  options.value[5].disabled = aa.includes("present=1");
  options.value[1].disabled = aa.includes("showShareBtn=1");
  return true;
};

const ratio = computed(() => {
  return (750 / height.value).toFixed(4);
});

const lastVal = computed(() => {
  if (jumpType.value === "h5") {
    let query = addressJump.value;
    if (addressParams.value) {
      query = encodeURIComponent(
        `${addressJump.value ? addressJump.value + "?" : ""}${
          addressParams.value
        }`
      );
    }
    const arr = common.value.map((item) => {
      if (item.includes("aspect_ratio")) {
        item = `aspect_ratio=${ratio.value}`;
      }
      if (item.includes("present_contentColor")) {
        item = `present_contentColor=${encodeURIComponent(contentColor.value)}`;
      }
      if (item.includes("web_loading_backcolor")) {
        item = `web_loading_backcolor=${encodeURIComponent(loadColor.value)}`;
      }
      if (item.includes("height_ratio")) {
        item = `height_ratio=${heightRatio.value}`;
      }
      return item;
    });
    return `${arr.join("&")}${arr.length ? "&" : ""}m=web&a=url&ul=${query}`;
  } else {
    return addressJump.value;
  }
});

const parse = () => {
  try {
    const path = props.url;
    if (!path) return;

    if (
      !path.includes("&ul=") ||
      !path.includes("m=web") ||
      !path.includes("a=url")
    ) {
      jumpType.value = "app";
      addressJump.value = path;
      return;
    }

    let str = "m=web&a=url&ul=";

    if (path.includes("m=web&a=url&ul=") === false) {
      str = "&ul=";
    }
    const [one, two] = path.split(str);
    const url = decodeURIComponent(two);
    const [fir, sec] = url.split("?");
    if (fir && fir !== "undefined") {
      addressJump.value = fir;
    }
    if (sec && sec !== "undefined") {
      addressParams.value = sec;
    }
    common.value.length = 0;
    one.split("&").forEach((item) => {
      if (item.includes("aspect_ratio")) {
        const ratio = Number(item.split("=")[1]);
        height.value = Number((750 / ratio).toFixed(0));
        common.value.push("aspect_ratio=");
      } else if (item.includes("present_contentColor")) {
        contentColor.value = decodeURIComponent(item.split("=")[1]);
        common.value.push("present_contentColor=");
      } else if (item.includes("web_loading_backcolor")) {
        loadColor.value = decodeURIComponent(item.split("=")[1]);
        common.value.push("web_loading_backcolor=");
      } else if (item.includes("height_ratio")) {
        heightRatio.value = Number(item.split("=")[1]);
        common.value.push("height_ratio=");
      } else if (
        item !== "m=web" &&
        item !== "a=url" &&
        item !== "hide_nav=0" &&
        item
      ) {
        common.value.push(item);
      }
    });
  } catch (error) {
    console.log("🦊 ~ error:", error);
  }
};

onMounted(() => {
  parse();
  document.querySelectorAll("style").forEach((item) => {
    if (item.getAttribute("data-cache-path")?.includes("rm38b5")) {
      bigBox.value?.appendChild(item.cloneNode(true));
    }
    if (item.getAttribute("data-token-hash") === "rm38b5") {
      bigBox.value?.appendChild(item.cloneNode(true));
    }
    if (item.getAttribute("data-css-hash")?.includes("1qb1s0s")) {
      bigBox.value?.appendChild(item.cloneNode(true));
    }
  });
  console.log("🦊 ~ bigBox:", props);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "mask",
    onClick: fn
  }, [
    _createElementVNode("div", {
      ref_key: "bigBox",
      ref: bigBox,
      class: "container",
      onClick: _cache[9] || (_cache[9] = _withModifiers(() => {}, ["stop"]))
    }, [
      _createElementVNode("p", {
        class: "✕",
        onClick: fn
      }, "✕"),
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createVNode(_unref(Select), {
          class: "w-200",
          value: jumpType.value,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((jumpType).value = $event)),
          options: typeOptions
        }, null, 8, ["value"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_unref(Input), {
          allowClear: "",
          value: addressJump.value,
          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((addressJump).value = $event)),
          class: "w-400"
        }, null, 8, ["value"])
      ]),
      (jumpType.value === 'app')
        ? (_openBlock(), _createElementBlock("a", _hoisted_5, "app原生跳转/参数汇总文档"))
        : _createCommentVNode("", true),
      (jumpType.value === 'h5')
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("div", null, [
              _createVNode(_unref(Select), {
                onChange: filterOption,
                value: common.value,
                "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((common).value = $event)),
                allowClear: "",
                mode: "multiple",
                options: options.value,
                class: "w-400"
              }, null, 8, ["value", "options"]),
              (common.value.some((item) => item.includes('aspect_ratio')))
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _hoisted_9,
                    _createVNode(_unref(InputNumber), {
                      class: "ml-10",
                      id: "inputNumber",
                      value: height.value,
                      "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((height).value = $event))
                    }, null, 8, ["value"]),
                    _hoisted_10
                  ]))
                : _createCommentVNode("", true),
              (common.value.some((item) => item.includes('height_ratio')))
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _hoisted_12,
                    _createVNode(_unref(InputNumber), {
                      class: "ml-10",
                      value: heightRatio.value,
                      "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((heightRatio).value = $event))
                    }, null, 8, ["value"])
                  ]))
                : _createCommentVNode("", true),
              (common.value.some((item) => item.includes('present_contentColor')))
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _hoisted_14,
                    _createVNode(_unref(Input), {
                      class: "w-200",
                      value: contentColor.value,
                      "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((contentColor).value = $event))
                    }, null, 8, ["value"]),
                    _hoisted_15
                  ]))
                : _createCommentVNode("", true),
              (common.value.some((item) => item.includes('web_loading_backcolor')))
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                    _hoisted_17,
                    _createVNode(_unref(Input), {
                      class: "w-200",
                      value: loadColor.value,
                      "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((loadColor).value = $event))
                    }, null, 8, ["value"]),
                    _hoisted_18
                  ]))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true),
      (jumpType.value === 'h5')
        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
            _hoisted_20,
            _createElementVNode("div", null, [
              _createVNode(_unref(Input), {
                allowClear: "",
                value: addressParams.value,
                "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((addressParams).value = $event)),
                class: "w-400 mb-10"
              }, null, 8, ["value"]),
              _hoisted_21,
              _createVNode(_unref(Input), {
                value: 'type=price&title=车库商店&productLevel=1',
                disabled: "",
                class: "w-400"
              })
            ])
          ]))
        : _createCommentVNode("", true),
      (jumpType.value === 'app' && addressJump.value.startsWith('http'))
        ? (_openBlock(), _createBlock(_unref(Alert), {
            key: 3,
            type: "warning",
            class: "alert",
            message: "如果是要在客户端内跳转到网页请选择［跳转H5］"
          }))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_22, [
        _hoisted_23,
        _createElementVNode("div", _hoisted_24, _toDisplayString(lastVal.value), 1),
        _createElementVNode("div", {
          class: "copyBtn ml-10",
          onClick: copy
        }, "复制")
      ]),
      _createElementVNode("div", _hoisted_25, [
        _createElementVNode("button", {
          class: "ant-btn ant-btn-default",
          onClick: fn
        }, "取消"),
        _createElementVNode("button", {
          onClick: _cache[8] || (_cache[8] = ($event: any) => (emit('ok', lastVal.value))),
          class: "ml-10 mr-10 ant-btn ant-btn-primary"
        }, " 确认 ")
      ]),
      _createVNode(_unref(InputNumber), { class: "none" }),
      _createVNode(_unref(Alert), {
        class: "none",
        message: "sss"
      })
    ], 512)
  ]))
}
}

})